export interface TermsStatusResponse {
    accepted: boolean;
    requires_update?: boolean;
    terms_version_required?: string;
    privacy_version_required?: string;
    terms_url: string;
    privacy_url: string;
    message?: string;
    status: number;
}

export function needsTermsAcceptance(
    data?: Pick<TermsStatusResponse, 'accepted' | 'requires_update'>,
): boolean {
    if (!data) {
        return true;
    }

    return data.accepted !== true || data.requires_update === true;
}

export type TermsStatusFailureReason = 'timeout' | 'not_found' | 'http_error' | 'unknown';

export function resolveTermsStatusFailureReason(error: unknown): TermsStatusFailureReason {
    if (error instanceof Error) {
        if (error.name === 'FetchTimeoutError') {
            return 'timeout';
        }
        if (error.message === 'Terms status not found') {
            return 'not_found';
        }
        if (error.message === 'Error checking terms status') {
            return 'http_error';
        }
    }

    return 'unknown';
}
